<template>
  <div>
    <div class="index-banner">
      <div class="side">
        <ul class="sideMenu-iconBox list-unstyled">
          <li v-if="!isLogin">
            <router-link to="/register" class="sideMenu-link">
              <img src="../assets/images/icon/join.png" alt="加入會員" />
              加入會員
            </router-link>
          </li>
          <li>
            <a href="#" @click.prevent="openLoginbox" class="sideMenu-link">
              <img src="../assets/images/icon/login.png" alt="會員登入/登出" />
              {{ isLogin ? "會員登出" : "會員登入" }}
            </a>
          </li>
          <li>
            <router-link to="/calendar" class="sideMenu-link">
              <img src="../assets/images/icon/Calendar.png" alt="行事曆" />
              行事曆
            </router-link>
          </li>
        </ul>
        <div class="index-copyright">
          <span>©</span>
          2020
          <span>台</span>
          <span>灣</span>
          <span>口</span>
          <span>腔</span>
          <span>衛</span>
          <span>生</span>
          <span>科</span>
          <span>學</span>
          <span>會</span> Taiwan Academy for Dental Hygiene , Designed by
          Jfetek.
        </div>
      </div>
      <div class="slider">
        <!-- swiper1 -->
        <swiper class="swiper" :options="swiperOption" v-if="banners.length">
          <!-- <swiper-slide
            v-for="(img, index) in banners"
            :key="index"
            :style="`backgroundImage:url(${
              img.Picture.indexOf('https://www.tadhtw.org') == -1
                ? 'https://www.tadhtw.org' + img.Picture
                : img.Picture
            })`"
          > -->
          <swiper-slide
            v-for="(img, index) in banners"
            :key="index"
            :style="`backgroundImage:url('${
              img.Picture.indexOf('https://www.tadhtw.org') == -1
                ? 'https://www.tadhtw.org' + img.Picture
                : img.Picture
            }')`"
          >
            <a :href="img.Url" class="banner-link">
              <div class="banner-title" v-html="img.Title"></div>
            </a>
          </swiper-slide>
          <!-- <div class="swiper-text-index">
            <div class="main-text">台灣口腔<br />衛生科學學會</div>
            <div class="sub-text">
              整合牙科學會及研究人才<br />
              提升國內醫療水準
            </div>
            <div class="link-text">
              <a
                href="#"
                @click.prevent="
                  toActivityDetail('1')
                "
                >研討會報名
                <img
                  src="../assets/images/icon/index_go.png"
                  alt="前往研討會報名"
              /></a>
            </div>
          </div> -->
          <div class="goMainBtn" id="goNextArea">
            <span class="material-icons">south</span>
            <span class="scroll">S</span>
            <span class="scroll">C</span>
            <span class="scroll">R</span>
            <span class="scroll">O</span>
            <span class="scroll">L</span>
            <span class="scroll">L</span>
            <span class="scroll"></span>
            <span class="scroll">D</span>
            <span class="scroll">O</span>
            <span class="scroll">W</span>
            <span class="scroll">N</span>
          </div>
        </swiper>
      </div>
    </div>
    <div
      id="indexMain"
      class="contentContainer"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content-index">
        <!-- 學會簡介區 -->
        <div class="introduction-list">
          <div class="introduction-list-text">
            <div class="banner-text index">
              <h1>學會簡介</h1>
              <div class="banner-text-line"></div>
              <span>Introduction</span>
            </div>
            <h3>整合口腔衛生醫學研究人才，提升國內醫療水準</h3>
            <p>
              靈活的思維、精湛的醫術、緊密完善的研討內容，
              <br />更加細膩且高效的學術研究。
            </p>
          </div>
          <ul class="introduction-list-link list-unstyled">
            <li>
              <a href="#" @click.prevent="toIntroduction('學會歷史')">
                <img
                  src="../assets/images/icon/學會沿革.png"
                  alt="學會沿革"
                />History <br />學會沿革
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('學會章程')">
                <img
                  src="../assets/images/icon/學會章程.png"
                  alt="學會章程"
                />Articles <br />學會章程
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('理事長的話')">
                <img
                  src="../assets/images/icon/理事長的話.png"
                  alt="理事長的話"
                />President <br />理事長的話
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('理事監名錄')">
                <img
                  src="../assets/images/icon/名錄.png"
                  alt="理事監名錄"
                />Supervisory <br />理事監名錄
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('組織架構')">
                <img
                  src="../assets/images/icon/組織架構.png"
                  alt="組織架構"
                />Organization <br />組織架構
              </a>
            </li>
          </ul>
        </div>
        <!-- 活動剪影區 -->
        <div class="Activity-list" v-if="Albums && Albums.length > 0">
          <swiper class="swiper" :options="activitySwiperOption">
            <swiper-slide v-for="item in Albums" :key="item.Id">
              <a
                href="#"
                @click.prevent="
                  toActivity('photo', `${item.Title}`, `${item.Id}`)
                "
              >
                <img :src="item.Photos[0]" alt />
              </a>
              <div>{{ item.Title }}</div>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div class="banner-text index inSwiper" slot="pagination">
              <h1>活動剪影</h1>
              <div class="banner-text-line"></div>
              <span>Activity silhouette</span>
            </div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
            <span class="material-icons prev" slot="button-prev"> west </span>
            <span class="material-icons next" slot="button-next"> east </span>
          </swiper>
        </div>
        <!-- 最新消息區 -->
        <div class="News-list">
          <div class="News-list-text">
            <div class="banner-text index">
              <h1>最新消息</h1>
              <div class="banner-text-line"></div>
              <span>News</span>
            </div>
            <p>
              靈活的思維、精湛的醫術、緊密完善的研討內容，
              <br />更加細膩且高效的學術研究。
            </p>
            <div class="btn blue-btn index">
              <router-link to="/news">更多消息</router-link>
            </div>
          </div>
          <div class="News-list-link">
            <img src="../assets/images/index_news.jpg" alt="最新消息" />
            <ul class="News-list-ul list-unstyled">
              <li v-for="item in news" :key="item.Id">
                {{ item.CreatedOn | moment("YYYY.MM.DD") }}
                <div
                  class="eventCard-detail-tag index green"
                  v-if="
                    item.Categories &&
                    item.Categories.length > 0 &&
                    item.Categories[0].Title === '國際訊息'
                  "
                >
                  {{ item.Categories[0].Title }}
                </div>
                <div
                  class="eventCard-detail-tag index orange"
                  v-else-if="item.Categories && item.Categories.length > 0"
                >
                  {{ item.Categories[0].Title }}
                </div>
                <a href="#" @click.prevent="goNewsDetail(item.Id)">{{
                  item.Title
                }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 學術活動區 -->
        <div class="event-list">
          <div class="event-list-sliderArea">
            <div class="text-index">
              行事曆
              <!-- {{ $moment(new Date()).format("YYYY.MM") }}
              <span>行事曆</span> -->
            </div>
            <swiper
              class="swiper"
              :options="eventSwiperOption"
              ref="eventSwiper"
            >
              <swiper-slide v-for="item in filterEventList" :key="item.Id">
                <a
                  class="activity-index-wrap"
                  href="#"
                  @click.prevent="toActivityDetail(item.Id)"
                >
                  <img v-if="item.Picture" :src="item.Picture" alt />
                  <img v-else :src="Images[0].Url" alt />
                  <div class="event-list-tag" v-if="item.Categories[0] === 1">
                    會員大會
                  </div>
                  <div class="event-list-tag" v-else-if="item.Categories[0] === 2">
                    學術研討會
                  </div>
                  <div class="event-list-tag" v-else-if="item.Categories[0] === 3">
                    相關合辦活動
                  </div>
                  <div class="event-list-tag" v-else>其他</div>
                </a>
                <div class="event-list-title">
                  <div class="date">
                    {{ item.ActivityStartOn | moment("YYYY.MM.DD") }}~{{
                      item.ActivityEndOn | moment("YYYY.MM.DD")
                    }}
                  </div>
                  {{ item.Title }}
                </div>
              </swiper-slide>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
              <!-- <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
          </div>
          <div class="event-list-filterArea">
            <div class="title">
              <div class="banner-text index">
                <h1>學術活動</h1>
                <div class="banner-text-line"></div>
                <span>Event / meeting itinerary</span>
              </div>
            </div>
            <div class="supervisory-btnBlock index">
              <template v-for="(item, index) in eventCategrory">
                <div v-if="index === 0" :key="'btnBlock' + index">
                  <button
                    class="btn btn-supervisory active"
                    :data-id="index"
                    @click="setSupervisory(index)"
                  >
                    {{ item.Title }}
                  </button>
                </div>
                <div v-else :key="'btnBlock' + index">
                  /
                  <button
                    class="btn btn-supervisory"
                    :data-id="index"
                    @click="setSupervisory(index)"
                  >
                    {{ item.Title }}
                  </button>
                </div>
              </template>
            </div>
            <p>
              提供完整國內外研討會及每年各項學術年會與地會開辦及投稿日期時間，以便各位使用者查詢與確認，若有任何問題，可聯絡通知我們，以便後續協助與服務，謝謝!!
            </p>
            <div class="swiper-customer-btn">
              <span class="material-icons prev" slot="button-prev"> west </span>
              <span class="material-icons next" slot="button-next"> east </span>
            </div>
            <div class="btn blue-btn index">
              <router-link to="/calendar">查看行事曆</router-link>
            </div>
          </div>
        </div>
        <!-- 贊助夥伴區 -->
        <!-- <div class="introduction-list">
          <div class="introduction-list-text">
            <div class="banner-text index">
              <h1>贊助夥伴</h1>
              <div class="banner-text-line"></div>
              <span>Patron</span>
            </div>
            <p>
              贊助夥伴
            </p>
          </div>
          <ul class="introduction-list-link list-unstyled">
            <li>
              <a href="#" @click.prevent="toIntroduction('學會歷史')">
                <img
                  src="../assets/images/icon/學會沿革.png"
                  alt="學會沿革"
                />History <br />學會沿革
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('學會章程')">
                <img
                  src="../assets/images/icon/學會章程.png"
                  alt="學會章程"
                />Articles <br />學會章程
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="toIntroduction('理事長的話')">
                <img
                  src="../assets/images/icon/理事長的話.png"
                  alt="理事長的話"
                />President <br />理事長的話
              </a>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import NewsApi from '@/assets/api/news';
import activityApi from '@/assets/api/activity';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import $ from 'jquery';
import BG from '../assets/images/index_bg_xl.png';

export default {
  name: 'Index',
  components: {
    // MagazineCard,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      BG,
      swiperOption: {
        spaceBetween: 30,
        loop: true,
        // effect: 'fade',
        autoplay: { delay: 6000 },
      },
      activitySwiperOption: {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerGroup: 2,
        loop: true,
        loopFillGroupWithBlank: true,
        // effect: 'fade',
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
      },
      eventSwiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: false,
        loopFillGroupWithBlank: true,
        // effect: 'fade',
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
        observer: true,
        observeParents: true,
      },
      Images: [
        {
          // eslint-disable-next-line global-require
          Url: require('@/assets/images/banner/index_banner.jpg'),
        },
      ],
      news: [],
      newsCategrory: [],
      Albums: [],
      eventCategrory: [
        {
          Title: '全部',
        },
        // {
        //   Title: '國際活動',
        // },
        // {
        //   Title: '國內活動',
        // },
        // {
        //   Title: '年會',
        // },
        {
          Title: '會員大會',
        },
        {
          Title: '學術研討會',
        },
        {
          Title: '相關合辦活動',
        },
      ],
      nowIndex: 0,
      eventList: [],
      isScroll: true,
      mainHeigh: 0,
      banners: [],
    };
  },
  methods: {
    openLoginbox() {
      const vm = this;
      if (!vm.isLogin) {
        // eslint-disable-next-line no-shadow
        const Loginbox = document.getElementById('loginbox');
        // console.log(Loginbox);
        vm.MemberPopup = false;
        const tops = $(document).scrollTop();
        $(document).bind('scroll', () => {
          $(document).scrollTop(tops);
        });
        Loginbox.style.display = 'flex';
      } else {
        vm.$store.commit('ISLOGIN', false);
        vm.$swal({
          icon: 'success',
          text: '已登出!',
          confirmButtonText: '確定',
        });
      }
    },
    toActivityDetail(id) {
      const vm = this;
      vm.$router.push(`/activity/${id}`);
    },
    toIntroduction(text) {
      const vm = this;
      vm.$router.push({
        name: 'Introduction',
        params: { data: text },
      });
    },
    toActivity(text, title, id) {
      // 獲取從哪裡來、標題、ID
      const vm = this;
      // 利用router的功能，將參數帶到下一頁去
      vm.$router.push({
        name: 'Activity',
        params: { data: text, title, id },
      });
    },
    setSupervisory(index) {
      const vm = this;
      $('.btn-supervisory').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // eslint-disable-next-line no-restricted-globals
      // console.log(event.target.getAttribute('data-id'), index, event.target);
      vm.nowIndex = index;
      // this.$refs.eventSwiper.swiper.destroy();
      vm.$nextTick(() => {
        // console.log(vm.$refs.eventSwiper);
        vm.$refs.eventSwiper.mountInstance();
        vm.$refs.eventSwiper.update();
        // this.$refs.eventSwiper.swiper.instantSwiper();
        // vm.$refs.eventSwiper.swiper.update();
      });
    },
    goNewsDetail(id) {
      const vm = this;
      vm.$router.push(`/news/${id}`);
    },
    getNews() {
      const vm = this;
      NewsApi.getNewsCategories().then((res) => {
        // 先取得所有分類
        if (res.status === 200) {
          vm.newsCategrory = res.data.Data;
          NewsApi.getIndexNews().then((data) => {
            // 再取得所有新聞資料
            if (data.status === 200) {
              vm.news = data.data.Data.News;
              vm.news.forEach((item) => {
                // 對新聞資料進行遍歷
                vm.newsCategrory.forEach((cate) => {
                  // 對分類進行遍歷
                  if (cate.Id === item.Categories[0]) {
                    // 當分類的ID等於新聞資料分類第一筆的ID時，把符合的分類資料塞進新聞資料分類的第一筆
                    // eslint-disable-next-line no-param-reassign
                    item.Categories[0] = cate;
                  }
                });
              });
            }
          });
        }
      });
    },
    getAlbums() {
      const vm = this;
      activityApi.getAllAlbums(1).then((res) => {
        if (res.status === 200) {
          vm.Albums = res.data.Data.Activities;
        }
      });
    },
    getActivityMonth(month) {
      const vm = this;
      // activityApi.getMonthActivity(month).then((res) => {
      //   if (res.status === 200) {
      //     vm.eventList = res.data.Data.Activities;
      //   }
      //   // console.log(res);
      // });
      activityApi.getAllActivity(1).then((res) => {
        if (res.status === 200) {
          if (vm.eventList.length === 0) {
            // vm.events = res.data.Data.Activities.filter(
            //   (item) => item.Photos.length === 0,
            // );
            vm.eventList = res.data.Data.Activities;
          }
        }
      });
    },
    getBanner(page) {
      const vm = this;
      NewsApi.getBanners(page).then((res) => {
        if (res.status === 200) {
          vm.banners = res.data.Data;
        }
      });
    },
  },
  mounted() {
    const vm = this;
    $('#goNextArea').click((e) => {
      e.preventDefault();
      $('html,body').animate(
        {
          scrollTop: $('#indexMain').offset().top,
        },
        300,
      );
    });
    // 首頁 banner 滾動滑鼠會直接移到主要區塊
    const tmpHeaderHeight = $('#indexMain').offset().top; // 避免在其他頁找不到所以放在外面
    $(window).scroll(() => {
      const tmpScrollTop = $(window).scrollTop();
      if (vm.$route.name === 'Index') {
        // 避免在其他頁面觸發
        if (tmpHeaderHeight >= tmpScrollTop && vm.isScroll) {
          $('html,body').animate(
            {
              scrollTop: tmpHeaderHeight,
            },
            300,
          );
          vm.isScroll = false;
        }
        if (tmpScrollTop === 0) {
          vm.isScroll = true;
        }
      }
    });

    $(window).resize(() => {
      if (window.innerWidth <= 768 && window.innerWidth > 420) {
        vm.eventSwiperOption.slidesPerView = 3;
      } else if (window.innerWidth <= 420) {
        vm.eventSwiperOption.slidesPerView = 2;
      }
      vm.$nextTick(() => {
        // console.log(vm.$refs.eventSwiper);
        vm.$refs.eventSwiper.mountInstance();
        vm.$refs.eventSwiper.update();
        // this.$refs.eventSwiper.swiper.instantSwiper();
        // vm.$refs.eventSwiper.swiper.update();
      });
    });
    // $('.sideMenu').addClass('d-none');
    // if ('onmousewheel' in window) {
    //   window.onmousewheel = this.MouseWheel();
    // } else if ('onmousewheel' in document) {
    //   document.onmousewheel = this.MouseWheel();
    // } else if ('addEventListener' in window) {
    //   window.addEventListener('mousewheel', this.MouseWheel(), false);
    //   window.addEventListener('DOMMouseScroll', this.MouseWheel(), false);
    // }
    // window.addEventListener('scroll', this.MouseWheel, true);
  },
  created() {
    const vm = this;
    vm.getNews();
    vm.getAlbums();
    vm.getActivityMonth(vm.$moment().format('M'));
    vm.getBanner(1);
    // vm.news = [
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //     // eslint-disable-next-line global-require
    //     Image: require('@/assets/images/continuing_pic.jpg'),
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '視網膜醫學會網站 全新改版，會員/準會員 登入說明～',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: '7aecb625-4870-40af-a46d-4b6b80027ef3',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '學會',
    //     Title: '中華民國視網膜醫學會 民國108年 工作計畫',
    //     CategoryId: '0d740489-c8c0-4f24-9de5-61f5b4f27cbf',
    //   },
    //   {
    //     Id: 'abcdefsdasdsdadsadasdasd',
    //     StartOn: '2019-01-07',
    //     EndOn: '',
    //     Sort: '國際訊息',
    //     Title: '轉知「醫策會20週年國際論壇」徵文訊息。安安',
    //     CategoryId: '8f7587e8-3649-4dce-a525-c7a54499841d',
    //   },
    // ];
    // vm.eventList = [
    //   {
    //     Title: 'Baltimore, 國際活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國際活動',
    //   },
    //   {
    //     Title: 'Baltimore, 國際活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國際活動',
    //   },
    //   {
    //     Title: 'Baltimore, 國內活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國內活動',
    //   },
    //   {
    //     Title: 'Baltimore, 年會',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '年會',
    //   },
    //   {
    //     Title: 'Baltimore, 國際活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國際活動',
    //   },
    //   {
    //     Title: 'Baltimore, 國際活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國際活動',
    //   },
    //   {
    //     Title: 'Baltimore, 國內活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國內活動',
    //   },
    //   {
    //     Title: 'Baltimore, 年會',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '年會',
    //   },
    //   {
    //     Title: 'Baltimore, 年會',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '年會',
    //   },
    //   {
    //     Title: 'Baltimore, 國內活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國內活動',
    //   },
    //   {
    //     Title: 'Baltimore, 國內活動',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '國內活動',
    //   },
    //   {
    //     Title: 'Baltimore, 年會',
    //     Time: '2020.05.03~2020.05.07',
    //     Category: '年會',
    //   },
    // ];
    if (vm.screenWidth <= 768) {
      vm.eventSwiperOption.slidesPerView = 3;
    }
    if (vm.screenWidth <= 420) {
      vm.eventSwiperOption.slidesPerView = 2;
    }
  },
  computed: {
    // newsList() {
    //   const vm = this;
    //   let tmpNews = [];
    //   if (vm.news.length > 4) {
    //     vm.news.length = 4;
    //     tmpNews = vm.news;
    //   } else {
    //     tmpNews = vm.news;
    //   }
    //   return tmpNews;
    // },
    filterEventList() {
      const vm = this;
      let tmpList = [];
      switch (vm.nowIndex) {
        case 0:
          tmpList = vm.eventList;
          break;
        case 1:
          tmpList = vm.eventList.filter((item) => item.Categories[0] === 1);
          break;
        case 2:
          tmpList = vm.eventList.filter((item) => item.Categories[0] === 2);
          break;
        case 3:
          tmpList = vm.eventList.filter((item) => item.Categories[0] === 3);
          break;
        default:
          break;
      }
      return tmpList;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    screenWidth() {
      return this.$store.state.screenWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.index-banner {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100vh;

  @media (max-width: 420px) {
    height: 220px;
  }
  .slider {
    width: 100%;
    height: calc(100%);
    padding-left: 100px;
    @media (max-width: 420px) {
      padding: 0;
    }
    .swiper {
      height: calc(100%);
      .swiper-slide {
        background-position: center;
        background-size: cover;

        @media (max-width: 420px) {
          background-repeat: no-repeat;
        }
        a {
          width: 100%;
          height: 100%;
          display: flex;
          position: relative;
          text-decoration: none;
        }

        .banner-title {
          position: absolute;
          top: 50%;
          left: 15%;
          transform: translate(0%, -50%);
          text-align: center;

          @media (max-width: 1440px) {
            left: 5%;
          }

          @media (max-width: 1024px) {
            top: 20%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
          }

          @media (max-width: 480px) {
            top: 40%;
          }

          ::v-deep h1 {
            color: #001139;
            font-size: 5rem;
            @media (max-width: 767px) {
              font-size: 2rem;
            }
          }
          ::v-deep h3 {
            color: #263357;
            font-size: 3rem;
            @media (max-width: 767px) {
              font-size: 1.5rem;
            }
          }
        }
      }
    }
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100px;
    background-color: #fff;
    z-index: 100;
    box-shadow: 10px 0px 10px -10px rgba(0, 0, 0, 0.3);
    padding-top: 5rem;
    @media (max-width: 1366px) {
      padding-top: 1rem;
    }

    @media (max-width: 420px) {
      display: none;
    }
    .sideMenu-link {
      display: block;
      text-align: center;
      margin-bottom: 1rem;
    }
    .index-copyright {
      margin: auto;
      font-size: 0.6rem;
      color: #263357;
      writing-mode: vertical-rl;
      bottom: 0;
      height: 75%;
      text-align: end;
      @media (max-width: 1366px) {
        height: 65%;
      }
      @media (max-width: 1024px) {
        height: 75%;
      }
      span {
        display: inline-block;
        transform: rotate(90deg);
      }
    }
  }
}

.swiper-text-index {
  position: absolute;
  left: 10%;
  top: 20%;
  text-align: center;

  @media (max-width: 420px) {
    top: 10%;
    left: 5%;
  }
  @media (max-width: 375px) {
    top: 20%;
  }
  @media (max-width: 320px) {
    top: 10%;
  }

  .main-text {
    font-size: 5rem;
    color: #001139;
    font-weight: bold;
    @media (max-width: 420px) {
      font-size: 4rem;
    }
    @media (max-width: 375px) {
      font-size: 3rem;
    }
  }

  .sub-text {
    font-size: 3rem;
    color: #263357;
    margin-bottom: 4rem;
    @media (max-width: 420px) {
      font-size: 2rem;
    }
  }
  .link-text {
    a {
      font-size: 1.5rem;
      color: #263357;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.goMainBtn {
  position: absolute;
  left: calc(50% - 54px);
  bottom: 5%;
  cursor: pointer;

  .scroll {
    display: inline-block;
    animation: scrollAnimate 1s ease infinite alternate;
  }
  .scroll:nth-child(2) {
    animation-delay: 0s;
  }
  .scroll:nth-child(3) {
    animation-delay: 0.1s;
  }
  .scroll:nth-child(4) {
    animation-delay: 0.2s;
  }
  .scroll:nth-child(5) {
    animation-delay: 0.3s;
  }
  .scroll:nth-child(6) {
    animation-delay: 0.4s;
  }
  .scroll:nth-child(7) {
    animation-delay: 0.5s;
  }
  .scroll:nth-child(8) {
    animation-delay: 0.6s;
  }
  .scroll:nth-child(9) {
    animation-delay: 0.7s;
  }
  .scroll:nth-child(10) {
    animation-delay: 0.8s;
  }
  .scroll:nth-child(11) {
    animation-delay: 0.9s;
  }
  .scroll:nth-child(12) {
    animation-delay: 1s;
  }

  .material-icons {
    padding-bottom: 5px;
    display: block;
    text-align: center;
    animation: scrollAnimate 1s ease infinite alternate;
    animation-delay: 0.5s;
  }
}

@keyframes scrollAnimate {
  0% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-10px);
  }
}

.content-index {
  padding: 55px 110px;

  @media (max-width: 1024px) {
    padding: 55px 50px;
  }
  @media (max-width: 420px) {
    padding: 55px 20px;
  }
}

.introduction-list {
  padding: 4rem 0;
  display: flex;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  .introduction-list-text {
    @media (max-width: 1024px) {
      margin-bottom: 2rem;
    }
    h3 {
      font-size: 1.1rem;
      color: #001139;
      padding: 1rem 0;
      letter-spacing: 1.2px;
    }
    p {
      color: #676767;
      margin-bottom: 0;
      letter-spacing: 1.2px;
    }
  }
}

.introduction-list-link {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex: 1;
  margin-bottom: 0;
  @media (max-width: 420px) {
    flex-wrap: wrap;
  }

  li {
    @media (max-width: 420px) {
      margin-bottom: 1rem;
      margin-right: 1rem;
    }
  }
  a {
    text-align: center;
    display: block;
    text-decoration: none;
    color: #464646;
    transition: all 0.3s ease-in-out;

    &:hover {
      color: #f68e56;
    }
  }

  img {
    display: block;
    margin: auto;
    margin-bottom: 1rem;
  }
}

.banner-text {
  &.index {
    position: static;
    span {
      font-size: 18px;
    }
  }

  &.inSwiper {
    position: absolute;
    top: 0;
    right: 0;
    left: inherit;
    z-index: 101;
  }
}

.Activity-list {
  // height: 380px;
  margin-bottom: 5rem;

  .swiper-slide {
    // padding-top: 100px;
    img {
      max-height: 375px;
      width: 100%;
    }

    &.swiper-slide-active {
      padding-top: 0;
    }
  }
  .prev {
    position: absolute;
    bottom: 0;
    left: 40%;
    z-index: 10;
    color: #4b4b4b;
    @media (max-width: 420px) {
      left: 35%;
    }
  }
  .next {
    position: absolute;
    bottom: 0;
    left: 45%;
    z-index: 10;
    color: #4b4b4b;
  }

  // .swiper-slide-active {
  //   // padding-bottom: 50px;
  // }
  .swiper-slide-next {
    padding-top: 100px;
  }
}

.News-list {
  display: flex;
  justify-content: space-between;
  @media (max-width: 420px) {
    flex-direction: column;
  }
  .News-list-text {
    position: relative;
    p {
      color: #676767;
      margin-bottom: 0;
      padding: 2rem 0;
      letter-spacing: 1.2px;
    }
  }
  .News-list-link {
    // flex: 1;
    img {
      width: 100%;
    }
    .News-list-ul {
      padding: 1rem;

      @media (max-width: 1024px) {
        padding: 1rem 0;
      }
      li {
        padding: 0.5rem;
        font-size: 1rem;
        color: #676767;
        line-height: 1;
        a {
          color: #676767;
          &:hover {
            color: #001139;
          }

          @media(max-width:480px) {
            display: block;
          }
        }
      }
    }
  }
}

.blue-btn {
  &.index {
    width: 184px;
    margin-right: 0;
    // position: absolute;
    left: 0;
    bottom: 15%;

    @media (max-width: 420px) {
      position: static;
    }
  }
}

.eventCard-detail-tag {
  &.index {
    display: inline-block;
    margin-left: 1rem;
    margin-right: 1.5rem;
  }
}

.event-list {
  // height: 380px;
  margin-bottom: 5rem;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  .swiper-slide {
    // padding-top: 100px;
    img {
      width: 100%;
      height: 130px;

      @media (max-width: 420px) {
        height: 100px;
      }
    }

    &.swiper-slide-active {
      padding-top: 0;
    }
  }
}

.event-list-sliderArea {
  width: 60%;
  @media (max-width: 1024px) {
    width: 100%;
  }

  .text-index {
    letter-spacing: 1.2px;
    color: #e8e7e7;
    font-size: 6rem;

    @media (max-width: 420px) {
      line-height: 1;
      font-size: 4.5rem;
      margin-bottom: 1rem;
    }

    span {
      font-size: 3rem;
      @media (max-width: 420px) {
        line-height: 1;
        font-size: 3rem;
      }
    }
  }
}

.activity-index-wrap {
  display: block;
  position: relative;
  .event-list-tag {
    color: #fff;
    background-color: #001139;
    display: inline-block;
    padding: 5px;
    padding-left: 10px;
    position: absolute;
    right: -3px;
    bottom: -2px;

    // @media (max-width: 420px) {
    //   top: 45%;
    // }
  }
}

.event-list-title {
  padding-top: 1rem;
  word-break: break-word;
  // @media (max-width: 420px) {
  //   padding-top: 2rem;
  // }
  .date {
    font-size: 0.8rem;
  }
}

.event-list-filterArea {
  flex: 1;
  padding: 0 1.5rem;
  position: relative;

  @media (max-width: 1024px) {
    padding: 1.5rem 1.5rem;
  }

  .title {
    text-align: right;
    .index {
      display: inline-block;

      .banner-text-line {
        width: 238px;
      }
    }
    // text-align: right;
  }
  .blue-btn.index {
    position: static;
    bottom: 0;
    left: 1.5rem;
  }
}

.supervisory-btnBlock {
  div {
    display: inline-block;
  }

  &.index {
    padding: 1rem 0;
    button {
      @media (max-width: 420px) {
        margin: 0;
      }
    }
  }
}

.swiper-customer-btn {
  padding: 1rem 0;
  color: #4b4b4b;
  .material-icons.prev {
    margin-right: 1rem;
  }
}
</style>
